/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PriceBookUsage } from '@gh/builder-shared-data';
import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { DateTimeTypes, EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { asString, beforeCurrentDate } from '@gh/core-util';
import { assign } from 'lodash';
import { PriceBookListItem } from '../../resources/price-book.model';
import { TranslationService } from '@gh/core-mls';

@Injectable()
export class PriceBookGridDefinition extends LayoutBasedGridDefinition {

  priceBookUsage: EnumDictionary<PriceBookUsage>;

  columnDefs = {
    withdrawalDate: buildDateTimeColumn(DateTimeTypes.ShortDate),
    repriceDate: buildDateTimeColumn(DateTimeTypes.ShortDate),
    releaseDate: buildDateTimeColumn(DateTimeTypes.ShortDate),
    usage: {
      valueFormatter: (params: any) =>
        params.value === PriceBookUsage.ChangeOrders ? this.translate.get('lbl_change_orders') :
          asString(this.priceBookUsage.get(params.value)),
    },
  };

  options = {
    getRowNodeId: (data: PriceBookListItem) => data.priceBookId,
    getRowClass: ({ data }: { data: PriceBookListItem }) => {
      if (beforeCurrentDate(data.withdrawalDate)) {
        return ROW_DELETED_CLASS;
      }
    },

  };

  constructor(private route: ActivatedRoute, private translate: TranslationService) {
    super();

    const { priceBookUsage } = getRouteInitData(route);

    assign(this, { priceBookUsage });
  }

}
